import MainContext from "../containers/Contexts/MainContext";
import React from "react";

export function withMainContext(WrappedComponent) {
  return class extends React.Component {
    render() {
      return (
        <MainContext.Consumer>
          {({ currencies }) => {
            // console.log("withMainContext", currencies);
            return <WrappedComponent {...this.props} currencies={currencies} />;
          }}
        </MainContext.Consumer>
      );
    }
  };
}
